// src/app/features/order-submitted/order-submitted.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-submitted',
  templateUrl: './order-submitted.component.html',
  standalone: true
})
export class OrderSubmittedComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Redirect to the Order Tracking page after 5 seconds
    setTimeout(() => {
      this.router.navigate(['/en-us/orders']);
    }, 3000); // 5000 milliseconds = 5 seconds
  }
}
